import React from 'react';
import { Box, BoxProps, Flex } from 'rebass';
import Icon, { IconType } from '../Icon/Icon';
import './Timeline.styles.css';

export type BoxPropsFix = BoxProps & {
  css?: any;
};

export type TimelineItemRailProps = {
  isInitial?: boolean;
  isLast?: boolean;
  isFinal?: boolean;
  icon?: IconType;
  iconColor?: string;
  noDot?: boolean;
};

const TimelineItemRail = (props: TimelineItemRailProps) => {
  const {
    isInitial,
    isLast,
    isFinal = false,
    iconColor = '#000',
    icon,
    noDot,
  } = props;

  return (
    <Flex
      width={['10px', '10px', '10px', '20px']} // compute?
      alignItems={'center'}
      flexDirection={'column'}
      flexShrink={0}
      // className={`${isInitial && 'is-intial'} ${isFinal && 'is-final'}`} // use these to hook onto
      className={isFinal ? 'is-final' : undefined} // use these to hook onto
    >
      <Box
        className="history-stroke-top"
        bg={isInitial ? 'transparent' : 'black'}
        width="1px"
        flexGrow="0"
        flexShrink="0"
        flexBasis={['8px', '8px', '8px', '3px']}
      />
      {!noDot && (
        <Flex
          p="5px"
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            // border: '2px solid',
            background: iconColor,
            borderColor: 'paneBg',
            position: 'relative',
            borderRadius: '50%',
            '*': {
              display: ['none', 'none', 'none', 'block'],
            },
          }}
        >
          {!icon && iconColor && <Box size="10px" />}
          {icon && <Icon icon={icon} color="white" size="10px" />}
        </Flex>
      )}
      <Box
        className="history-stroke-bottom"
        bg={isLast && isFinal ? 'transparent' : 'black'}
        width="1px"
        flexGrow="1"
        flexShrink="1"
        // flexBasis={icon ? 'auto' : '50%'}
        sx={
          isFinal
            ? {
                // Can only hook into Radix state via css
                '.radix--AccordionItem[data-state="closed"] .is-final &': {
                  backgroundColor: 'transparent',
                  // width: '10px',
                },
              }
            : undefined
        }
      />
    </Flex>
  );
};

export default TimelineItemRail;
